// each page maintain an active error list (which come from yup)
// containg the error message and the component name the error refers to

import { object as yupObject, array as yupArray, string, number, date, InferType, addMethod } from 'yup';

export function getErrorListFromYupError(yupError) {
    const errors = JSON.parse(JSON.stringify(yupError))
    //console.log(errors)
    return errors.inner.map(error => {
                             return {fieldName: error.path, message: error.message, params: error.params}                            
    })

}

export function getErrorMessage(errorList, fieldName) {
    if (errorList === undefined) return undefined;
    
    const matched = errorList.find(e => e.fieldName === fieldName)

    if (matched) return matched.message
    else return undefined
}

export function getErrorMessageForArray(errorList, fieldName, index) {
  if (errorList === undefined) return undefined;
  
  const matched = errorList.find(e => e.fieldName === fieldName)
  if (matched) {
    //console.log(matched.params.indexes.includes(index))
    if (matched.params.indexes.includes(index)) return matched.message
    else return undefined
  }

  return undefined
}


export const snippetDataTimerValidationSchema = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
    
    timerSettings: string().test(
      'validateInputDateFormat',
      '',
      (value, context) => {
        const valueJson = JSON.parse(value)
        if (!valueJson.timerType.startsWith('custom')) return true;

        if (valueJson.inputDateFormat === undefined || valueJson.inputDateFormat === '')
          return context.createError({path: 'timerSettingsInputDateFormat', message: 'Required field'});
        else return true;
      }
    ).test(
      'validateHrefAfterExpiry',
      '',
      (value, context) => {
        const valueJson = JSON.parse(value)
        const urlValidator = string().url();
        const isValidUrl = urlValidator.isValidSync(valueJson.hrefAfterExpiry)
        if (isValidUrl) return true;
        else return context.createError({path: 'timerSettingsHrefAfterExpiry', message: 'Must be a valid url'});

      }
    )
    
    /*timerSettings: yupObject({
      inputDateFormat: string().required("Required field"),
    })*/
  });

export const snippetDataValidationSchemaBase = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
  });

  export const snippetDataValidationSchemaGenerator = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field"),
  });

  export const snippetDataValidationSchemaOSTracker = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),

    snippetSettings: yupObject().test(
      'validateDefaultHref',
      '',
      (value, context) => {
        //console.log(value)
        if (value.Other.href && value.Other.href.length > 0) return true;
        else return context.createError({path: 'snippetSettingsDefaultHref', message: 'Required field'});

      }
    ).test(
      'validateDefaultImg',
      '',
      (value, context) => {
        //console.log(value)
        if (value.Other.imgB64 && value.Other.imgB64.length > 0) return true;
        else return context.createError({path: 'snippetSettingsDefaultImg', message: 'Required'});

      }
    )
  });

  export const snippetDataValidationSchemaScratch = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'coverImgUploaded',
      '',
      (value, context) => {
        //console.log(value)
        if (value.teaserImgB64.length > 0) return true;
        else return context.createError({path: 'snippetSettingsCoverImg', message: 'You must upload a cover image'});

      }
    ).test(
      'revealImgUploaded',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.revealImages.forEach((img, index) => {if (img.imgB64.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsRevealImg', message: 'You must upload a reveal image', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'revealHref',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.revealImages.forEach((img, index) => {if (img.href.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsRevealHref', message: 'Href is required', params: {indexes: errors}});
        else return true;
      }
    )

  });

  export const snippetDataValidationSchemaSpinningWheel = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    
    wheelSettings: yupObject().test(
      'slicesHref',
      '',
      (value, context) => {
        const errors = []
        value.slices.forEach((slice, index) => {if (slice.href.length === 0 && !slice.notUsed) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'wheelSettingsSlicesHref', message: 'Href is required', params: {indexes: errors}});
        else return true;
      }
    ).test(
      'slicesMapping',
      '',
      (value, context) => {
        const errors = []
        value.slices.forEach((slice, index) => {if (slice.mapping.length === 0 && !slice.notUsed) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'wheelSettingsSlicesMapping', message: 'Mapping is required', params: {indexes: errors}});
        else return true;
      }
    )

  });

  export const snippetDataValidationSchemaWeatherForecasts = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    href: string().required("Required field").url("Must be a valid url"),
    snippetSettings: yupObject().test(
      'defaultImage',
      '',
      (value, context) => {
        if (value === undefined || value.defaultImage === undefined) return context.createError({path: 'defaultImage', message: 'You must upload a default image'})

        const errors = []
        if (value.defaultImage.length === 0) return context.createError({path: 'defaultImage', message: 'You must upload a default image'});
        else return true;
      }
    )
  });


  export const weatherCollectionValidationSchema = yupObject({
    collectionName: string().required("Provide a value for collection name"),
    
    
    collection: yupArray().test(
      'isDefaultSet',
      '',
      (value, context) => {
        let found = false
        value.forEach((iconGroup, index) => {if (iconGroup.isDefault) found = true})
        if (!found) return context.createError({path: 'isDefaultSet', message: 'Set a default group'});
        else return true;
      }
    ).test(
      'areIconsSet',
      '',
      (value, context) => {
        let allSet = true
        value.forEach((iconGroup, index) => {if (iconGroup.iconDayDataURL.length === 0) allSet = false})
        if (!allSet) return context.createError({path: 'areIconsSet', message: 'Upload an image for all the Day Versions'});
        else return true;
      }
    )
  });

  export const snippetDataValidationSchemaTimedImages = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'timelineImages',
      '',
      (value, context) => {
        if (value === undefined || value === null ) return context.createError({path: 'timelineImages', message: 'An image is required', params: {indexes: [0,1]}})
        const errors = []
        value.assets.forEach((asset, index) => {if (asset.img.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'timelineImages', message: 'An image is required', params: {indexes: errors}});
        else return true;

      }
    ).test(
      'timelineHref',
      '',
      (value, context) => {
        if (value === undefined || value === null ) return context.createError({path: 'timelineHref', message: 'Href is required', params: {indexes: [0,1]}})
        const errors = []
        value.assets.forEach((asset, index) => {if (asset.href.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'timelineHref', message: 'Href is required', params: {indexes: errors}});
        else return true;

      }
    )
  });
  export const dataFunctionsValidationSchema = yupObject({
    functionPrettyName: string().required("Required field"),
    description: string().required("Required field"),
    metadata: yupObject().test(
      'functionParameters',
      '',
      (value, context) => {
        //console.log(value)
        
        
        if (value.parameters === undefined || value.parameters.length === 0 ) return true
        const errors = []
        value.parameters.forEach((p, index) => {if (p.name.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'functionParameters', message: 'Parameter name is required', params: {indexes: errors}});
        else return true;
        
      }
    )
  });
  export const snippetDataValidationSchemaVariantViewer_snippetSettings = yupObject({
    snippetSettings: yupObject().test(
      'bindings',
      '',
      (value, context) => {
        const errors = []
        value.variantsBindings.forEach((vb, index) => {if (vb.length === 0) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsVariantsBindings', message: 'Binding is required', params: {indexes: errors}});
        else return true;
      }
    )

  });


  export const snippetDataValidationSchemaSlidingPuzzle = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'puzzleImgUploaded',
      '',
      (value, context) => {
        //console.log(value)
        if (value.puzzleImgB64.length > 0) return true;
        else return context.createError({path: 'snippetSettingsPuzzleImg', message: 'You must upload a puzzle image'});

      }
    )

  });

  export const snippetDataValidationSchemaMemoryCards = yupObject({
    snippetName: string().required("Required field"),
    snippetDesc: string().required("Required field"),
    snippetSettings: yupObject().test(
      'images',
      '',
      (value, context) => {
        //console.log(value)
        const errors = []
        value.cardImages.forEach((img, index) => {if (img.imgB64 && img.imgB64.length === 0 && img.tagId === undefined) errors.push(index)})
        if (errors.length > 0) return context.createError({path: 'snippetSettingsImages', message: 'You must upload an image', params: {indexes: errors}});
        else return true;
      }
    ),

  });

  export const webPageSettingsValidationSchemaMemoryCards = yupObject({
    href: string().required("Required field"),
    templatePropValuesCollection: yupArray().test(
        'expirySettings',
        '',
        (value, context) => {
          //console.log(value)
          const errors = []
          value.forEach((kvp, index) => {
                                    if (kvp.propName === 'expired-msg' && kvp.propValue.length === 0) errors.push(kvp.propName)
                                    if (kvp.propName === 'expired-href' && kvp.propValue.length === 0) errors.push(kvp.propName)
                                    if (kvp.propName === 'expired-button-title' && kvp.propValue.length === 0) errors.push(kvp.propName)
                                    })
          if (errors.length > 0) return context.createError({path: 'expirySettings', message: 'Required field', params: {indexes: errors}});
          else return true;
        }
      ),

  });

  
  addMethod(string, 'CC_relaxedUrl', function (errorMessage = 'Invalid URL') {
    return this.test('is-relaxed-url', errorMessage, value => {
      if (!value) return false;
  
      try {
        const url = new URL(value);
        const isValidProtocol = url.protocol === 'http:' || url.protocol === 'https:';
        if (!isValidProtocol) return false;
  
        const allowedChars = '{}$';
        const query = url.search;
  
        const invalidChars = [...query].filter(char => {
          const code = char.charCodeAt(0);
          return code < 32 || (code >= 127 && !allowedChars.includes(char));
        });
  
        return invalidChars.length === 0;
      } catch {
        return false;
      }
    });
  });